module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.viewOrderModalDisplayed,
      "effect": "fade",
      "okText": "Refund"
    },
    on: {
      "closeOnEscape": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('span', [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title center"
  }, [_vm._v("Order No. " + _vm._s(_vm.order.external_id))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "slot": "modal-body"
    },
    slot: "modal-body"
  }, [_c('div', {
    staticClass: "portlet-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e()])]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped table-bordered table-advance table-hover"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(" Items ")]), _vm._v(" "), _c('td', [(_vm.order.order_items.length === 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "list-unstyled"
  }, _vm._l((_vm.order.order_items), function(item, index1) {
    return _c('li', [_vm._v(_vm._s(item.name) + " x " + _vm._s(item.item_qty) + " (" + _vm._s(_vm.formatUSD(item.item_price)) + ")\n\t\t\t\t\t\t\t\t\t\t"), _c('ul', _vm._l((item.modifier), function(modifier, index2) {
      return _c('li', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(modifier.name) + " "), (modifier.mod_qty !== 1) ? _c('span', [_vm._v(" x " + _vm._s(modifier.mod_qty) + " ")]) : _vm._e(), (modifier.order_modifier_option.length) ? _c('span', [_vm._v("(")]) : _vm._e(), _vm._l((modifier.order_modifier_option), function(option, optionIndex) {
        return _c('span', [_vm._v(_vm._s(option.option_name)), (optionIndex !== modifier.order_modifier_option.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }), (modifier.order_modifier_portion && modifier.order_modifier_portion.length) ? _c('span', [_vm._v("; ")]) : _vm._e(), _vm._l((modifier.order_modifier_portion), function(portion, portionIndex) {
        return _c('span', [_vm._v(_vm._s(portion.portion_name)), (portionIndex !== modifier.order_modifier_portion.length - 1) ? _c('span', [_vm._v(", ")]) : _vm._e()])
      }), (modifier.order_modifier_option.length) ? _c('span', [_vm._v(")")]) : _vm._e()], 2)
    }))])
  }))])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Store ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.location_name) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Status ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.status) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Type ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.type) + " ")])]), _vm._v(" "), (_vm.order.type === 'pickup' && _vm.order.pickup_later === 1) ? _c('tr', [_c('th', [_vm._v(" Pickup time ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.pickup_time) + " ")])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Tax ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.tax_percentage) + "% ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Tax amount ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatUSD(_vm.order.tax_amount)) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Delivery fee ")]), _vm._v(" "), _c('td', [_vm._v(" $" + _vm._s(_vm.order.delivery_fee) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Total ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatUSD(_vm.order.total)) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Notes ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.note || '-') + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Group order ")]), _vm._v(" "), _c('td', [(_vm.order.grouporder_id !== 0) ? _c('span', [_vm._v(" " + _vm._s(_vm.order.grouporder_id) + " ")]) : _c('span', [_vm._v(" no ")])])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Giftcard amount ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.formatUSD(_vm.order.giftcard_amount)) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Points earned ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.points_earned) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Created at ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.created_at) + " ")])]), _vm._v(" "), _c('tr', [_c('th', [_vm._v(" Updated at ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.order.updated_at) + " ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [(_vm.order.status !== 'refunded') ? _c('button', {
    staticClass: "btn btn-primary pull-left",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.refund()
      }
    }
  }, [_vm._v("Refund")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_vm._v("Close")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ae4754c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/UserManager/ViewOrder.vue
// module id = 730
// module chunks = 0